module.exports = __webpack_public_path__ + "img/_box_setting.f7df76a6.svg";